import React, { useEffect } from "react";

const FeeReceipt = () => {

  useEffect(() => {
    window.print();

    window.onafterprint = () => {
      window.history.back();
    };
  }, []);
  return (
    <div className="container-fluid mt-4">
      {/* Print Button */}
      <div className="d-flex justify-content-end d-print-none mb-3">
        <button className="btn btn-primary" onClick={() => window.print()}>
          Print Receipt
        </button>
      </div>

      {/* Student Copy with page break */}
      <div className="page-break">
          <div className="receipt-container">
      <div className="receipt-page">
        <div className="copy-label">Student Copy</div>

        <div className="text-center">
          <h4 className="fw-bold">Vrindavan Public School</h4>
          <p>Behind Mangalam City, Kacholiya</p>
          <p>Phone: +91 9799017406 | Email: VPSCHOMU@GMAIL.COM</p>
        </div>

        <hr />

        <div className="mb-3">
          <p><strong>Invoice No:</strong> 2314/1758</p>
          <p><strong>Date:</strong> 11-12-2023</p>
          <p><strong>Course/Class:</strong> NUR.th</p>
          <p><strong>Invoice To:</strong> anvi choudhary SO% saitan rewar</p>
          <p><strong>Phone:</strong> +91 9166709462</p>
          <p><strong>Address:</strong> Chomu</p>
        </div>

        <h5 className="text-center mt-4">Fee Receipt</h5>

        <table className="table table-bordered mt-3">
          <thead>
            <tr>
              <th>#Trans Id</th>
              <th>Date</th>
              <th>Fee Method</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>2314</td>
              <td>2023-12-11</td>
              <td>Cash</td>
              <td>₹3000</td>
            </tr>
          </tbody>
        </table>

        <p className="text-danger">
          <strong>No Refund Policy:</strong> Fees once paid will not be refunded.
        </p>
        <p className="fw-bold">Total: ₹3000</p>

        <div className="text-end mt-5">
          <strong>Signature</strong>
        </div>
        <p className="text-center mt-3">Thank you for your payment!</p>
      </div>
    </div>
      </div>

      {/* Office Copy without break */}
      <div>
       

          <div className="receipt-container">
      <div className="receipt-page">
        <div className="copy-label">Office Copy</div>

        <div className="text-center">
          <h4 className="fw-bold">Vrindavan Public School</h4>
          <p>Behind Mangalam City, Kacholiya</p>
          <p>Phone: +91 9799017406 | Email: VPSCHOMU@GMAIL.COM</p>
        </div>

        <hr />

        <div className="mb-3">
          <p><strong>Invoice No:</strong> 2314/1758</p>
          <p><strong>Date:</strong> 11-12-2023</p>
          <p><strong>Course/Class:</strong> NUR.th</p>
          <p><strong>Invoice To:</strong> anvi choudhary SO% saitan rewar</p>
          <p><strong>Phone:</strong> +91 9166709462</p>
          <p><strong>Address:</strong> Chomu</p>
        </div>

        <h5 className="text-center mt-4">Fee Receipt</h5>

        <table className="table table-bordered mt-3">
          <thead>
            <tr>
              <th>#Trans Id</th>
              <th>Date</th>
              <th>Fee Method</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>2314</td>
              <td>2023-12-11</td>
              <td>Cash</td>
              <td>₹3000</td>
            </tr>
          </tbody>
        </table>

        <p className="text-danger">
          <strong>No Refund Policy:</strong> Fees once paid will not be refunded.
        </p>
        <p className="fw-bold">Total: ₹3000</p>

        <div className="text-end mt-5">
          <strong>Signature</strong>
        </div>
        <p className="text-center mt-3">Thank you for your payment!</p>
      </div>
    </div>
      </div>

      {/* Styles */}
      <style>{`
        @media print {
          .d-print-none {
            display: none !important;
          }
          @page {
            size: A4;
            margin: 15mm;
          }
          .page-break {
            page-break-after: always;
          }
          .receipt-container {
            display: flex;
            justify-content: center;
            align-items: flex-end;
            min-height: calc(100vh - 30mm); /* bottom aligned within printable area */
          }
        }

        .receipt-page {
          background: #fff;
          border: 1px solid #ccc;
          padding: 20px;
          width: 100%;
          max-width: 800px;
          margin: auto;
        }

        .copy-label {
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 10px;
        }
      `}</style>
    </div>
  );
};

export default FeeReceipt;